import { render } from "./NewCompanyModal.vue?vue&type=template&id=1c985e64"
import script from "./NewCompanyModal.vue?vue&type=script&lang=js"
export * from "./NewCompanyModal.vue?vue&type=script&lang=js"

import "./NewCompanyModal.vue?vue&type=style&index=0&id=1c985e64&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__